import { colors, SectionHeader } from '@giphy/react-giphy-brand'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Content, CTAButton, FormContainer } from 'shared/components/form/form-components'
import withLocationState from 'shared/components/with-location-state'
import { message } from 'shared/redux/message'
import log from 'shared/util/log'
import styled from 'styled-components'
import { Join, TermsOfServiceLogin, ForgotPassword } from 'shared/components/form/copy'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import FacebookButton from 'shared/components/form/facebook-button'
import appendNextUrl from 'shared/components/form/get-next-url'
import LoginFields from 'shared/components/form/login/fields'

const sectionMargin = 6

const FacebookButtonWithMargin = styled(FacebookButton)`
    margin-bottom: ${sectionMargin}px;
`

const OR = styled(SectionHeader)`
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 4px;
    color: ${colors.giphyLightGrey};
`

@CSRFToken
@withRouter
@withLocationState(['formErrors'])
@connect(undefined, { message })
class Form extends PureComponent {
    state = {
        submitEnabled: false,
    }
    componentDidMount() {
        // for testing..
        // const errors = {
        //         username: [
        //             {
        //                 message: 'A user with that username already exists.',
        //                 code: 'unique',
        //             },
        //         ]
        // }
        const { formErrors, message } = this.props
        if (formErrors) {
            log.warn(`form errors:`, formErrors)
            const [firstKey] = Object.keys(formErrors)
            if (firstKey) {
                const [error] = formErrors[firstKey]
                if (error) {
                    message(error.message, 'error')
                }
            }
        }
    }
    areFieldsOkay = () => this.isFormValid
    onValidChange = isFormValid => {
        this.isFormValid = isFormValid
        this.setState({ submitEnabled: this.areFieldsOkay() })
    }
    submit = event => {
        event.stopPropagation()
        event.preventDefault()
        if (this.areFieldsOkay()) {
            this.form.submit()
        }
    }
    render() {
        const { submitEnabled } = this.state
        const { csrftoken } = this.props
        return (
            <FormContainer>
                <form method="POST" action={appendNextUrl(`/login`)} onSubmit={this.submit} ref={c => (this.form = c)}>
                    {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                    <Content>
                        <FacebookButtonWithMargin
                            label="Login with Facebook"
                            onClick={() => (location.href = `/login/facebook/${location.search}`)}
                        />
                        <OR>or</OR>
                        <LoginFields onValidChange={this.onValidChange} />
                        <CTAButton
                            color={submitEnabled ? colors.primaryCTA : colors.giphyDarkGrey}
                            disabled={!submitEnabled}
                        >
                            Log in
                        </CTAButton>
                        <TermsOfServiceLogin />
                        <Join />
                        <ForgotPassword />
                    </Content>
                </form>
            </FormContainer>
        )
    }
}

export default Form
